<template>
  <div class="vch-media-gallery__wrapper">
    <div class="vch-product-detail-image__zoom" @click="showModal" v-if="showZoom">
      <button class="vch-zoom__button">
        <svg role="img" :aria-label="zoomAriaLabel">
          <use href="/assets/sprite/icons.svg#search"></use>
        </svg>
      </button>
    </div>
    <div v-if="isModalOpen">
      <transition name="fade">
        <div class="vch-modal__backdrop" @click.self="closeModal">
          <div class="vch-modal__container">
            <div class="vch-modal__wrapper">
              <div class="vch-modal__body">
                <div class="vch-image-zoom__main">
                  <vch-zoom-image :src="imageSrc" @zoom-out="zoomOutHandler" :zoom-out-aria-label="zoomOutAriaLabel"/>
                </div>
              </div>
              <button class="vch-modal__close" @click="closeModal">
                {{zoomClose}}
              </button>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: 'vch-pdp-modal',
  props: {
    imageSrc: {
      type: String,
      required: true,
    },
	zoomClose: {
	  type: String,
	  required: true,
	},
  zoomAriaLabel:{
    type: String,
    required: false,
    default: 'Zoom',
  },
  zoomOutAriaLabel:{
    type: String,
    required: false,
    default: 'Zoom out',
  },
  },
  data() {
    return {
      imageSrc: this.imageSrc,
      isModalOpen: false,
      imageHandler: '',
      showZoom: true,
    };
  },
  mounted() {
    this.modalHeight();
    this.closeModal();

    window.addEventListener('resize', () => {
      this.modalHeight();
    });

    window.eventBus.$on('vch-remove-zoom-icon', (payload) => {
      if (payload != 0) {
        this.showZoom = false;
      } else {
        this.showZoom = true;
      }
    });
  },
  methods: {
    showModal() {
      this.isModalOpen = true;
      document.body.style.overflow = 'hidden';
    },
    closeModal() {
      this.isModalOpen = false;
      document.body.style.overflow = 'auto';
      this.imageHandler && this.imageHandler();
    },
    zoomOutHandler(handler) {
      this.imageHandler = handler;
    },

    modalHeight() {
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    },
  },
};
</script>

<style lang="scss" src="./pdp-modal.scss"></style>
